import { compose } from 'recompose';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import { actions as resultsDetailsAction } from '../../../../redux/healthboard/patientPortal/results-details-req';
import { actions as loggingActionRequest } from '../../../../redux/healthboard/patientPortal/logging-action-req';
import { resultsDetailsModalActions } from '../../../../redux/healthboard/patientPortal/results-details-modal';
import {
  loggedUserIdSelector,
  targetUserIdSelector,
} from '../../../../redux/context/selectors';
import {
  selectIdResultsDetailsModal,
  selectOpenedResultsDetailsModal,
  selectResultsDetailsEntity,
  selectResultsDetailsModalEntity,
  selectResultsDetailsPending,
  selectResultsDocument,
} from '../../../../redux/healthboard/patientPortal/selectors';

const mapStateToProps = state => ({
  openedResultsDetailsModal: selectOpenedResultsDetailsModal(state),
  ccdLabTestId: selectIdResultsDetailsModal(state),
  mainUserId: loggedUserIdSelector(state),
  targetUserId: targetUserIdSelector(state),
  pending: selectResultsDetailsPending(state),
  resultDocument: selectResultsDocument(state),
  entity: selectResultsDetailsModalEntity(state),
  detailsEntity: selectResultsDetailsEntity(state),
});

const mapDispatchToProps = {
  clear: resultsDetailsAction.clear,
  close: resultsDetailsModalActions.close,
  getDetailsReq: resultsDetailsAction.send,
  loggingViewAction: loggingActionRequest.send,
};

export const enhance = compose(
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
);



// WEBPACK FOOTER //
// ./src/components/PatientHealthboard/PatientPortal/ResultsDetailsModal/enhance.js